export const OFFICER_ROLE_NAMES = {
    "RO": "Relationship Officer",
    "BM": "Branch Manager",
    "BCM": "Branch Credit Manager"
};